// extracted by mini-css-extract-plugin
export default {"formBox":"FormBox_formBox__cQ4E5","button":"FormBox_button__UHO9L","title":"FormBox_title__2grk1"};